export default {"src":"/_next/static/media/kuwait.21735797.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};